import api from 'data/api';

export const loadChart = api('POST /api/mobile/dashboard/chart');
